export const GET_DOCUMENT_TYPES = '/documents/repository-types/:project_id';
export const GET_DOCUMENT_BY_TYPES = '/documents/repository/:project_id';
export const GET_DOCUMENT_GRAPH = '/documents/graphs/:project_id';
export const GET_EXPAND_DOCUMENT = '/documents/expand-tags/:project_id';
export const GET_SIMILAR_TAGS = '/documents/similar-docs/:project_id';
